import React from "react";
import { RelatedAnalysisTableProps } from "../../../@types/rldynamicanalysis/related_analysis";
import RelatedAnalysisTableRow from "./RelatedAnalysisTableRow";

const RelatedAnalysisTable: React.FC<RelatedAnalysisTableProps> = ({
  data: relatedAnalysisData
}) => (
  <table
    className="rl-cloud-sandbox__related-analysis-table"
    data-testid="rlcs_related_analysis_table"
  >
    <colgroup>
      <col style={{ width: "15.3%" }} />
      <col style={{ width: "29.9%" }} />
      <col style={{ width: "48.3%" }} />
      <col style={{ width: "3.5%" }} />
    </colgroup>
    <thead>
      <tr>
        <th>Classification</th>
        <th>SHA1 / URL</th>
        <th>Type</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {relatedAnalysisData &&
        relatedAnalysisData.map((rowData, index) => (
          <RelatedAnalysisTableRow
            analysisData={rowData}
            last={index === relatedAnalysisData.length - 1}
          />
        ))}
    </tbody>
  </table>
);

export default RelatedAnalysisTable;
